import type { IPagination } from "../../../../types/models/pagination.models.types";
import { useGetHttp } from "../../http.hook";

export interface INotificationExtended  {
  id: string;
  title: string;
  description: string;
  sentAt: string;
  metrics: {
    notificationCount: number;
  }
}

interface IResponse {
  broadcasts: Array<INotificationExtended>;
  pagination: IPagination;
}

export function useGetPastNotificationsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/notifications",
  });
}
